import { KybData } from './kyb.types.ts';
import { BusinessStatus } from '@Store/slices/customer/customer.types.ts';

export const getKybModel = (): KybData => {
  return {
    business: {
      externalId: '',
      name: '',
      naicsIndustry: '',
      businessType: '',
      status: BusinessStatus.NONE,
      missingLlcDocuments: [],
      primaryOwnershipPercent: 0,
    },
  };
};
